const EMPTY = 0
const UNDEFINED = 1
const DEFINED = 2

export default { EMPTY, UNDEFINED, DEFINED }
